import { createSlug } from '../../../utils/helpers';

/** URL segment for a service (stored slug, or derived from name, or doc id). */
export const getServicePathSegment = (service) => {
  if (!service) return '';
  const slug = String(service.slug || '').trim();
  if (slug) return slug;
  const fromName = createSlug(service.name || '');
  return fromName || service.id || '';
};

/** True when the route param is likely a Firestore document id, not a name slug. */
export const looksLikeFirestoreServiceId = (param) => {
  const value = String(param || '').trim();
  if (!value) return false;
  if (value.includes('-') && value.length < 30) return false;
  return value.length >= 16 && /^[a-zA-Z0-9]+$/.test(value);
};

/** Find a service by URL slug or legacy Firestore id. */
export const resolveServiceByRouteParam = (services, param) => {
  const value = String(param || '').trim();
  if (!value || !Array.isArray(services)) return null;

  const byId = services.find((s) => s.id === value);
  if (byId) return byId;

  const byStoredSlug = services.find((s) => getServicePathSegment(s) === value);
  if (byStoredSlug) return byStoredSlug;

  return null;
};

/** Unique slug for a service name within a company. */
export const assignUniqueServiceSlug = (name, existingServices = [], excludeId = null) => {
  const base = createSlug(name) || 'service';
  const taken = new Set(
    existingServices
      .filter((s) => s?.id && s.id !== excludeId)
      .map((s) => getServicePathSegment(s))
      .filter(Boolean)
  );

  let slug = base;
  let suffix = 2;
  while (taken.has(slug)) {
    slug = `${base}-${suffix}`;
    suffix += 1;
  }
  return slug;
};

/** Fields to persist when saving service name (keeps slug in sync). */
export const buildServiceSlugFields = (name, existingServices, excludeId = null) => ({
  slug: assignUniqueServiceSlug(name, existingServices, excludeId),
  searchName: String(name || '').toLowerCase(),
});
